import React from 'react';
import { styled } from "styled-components";
import { t } from 'ttag';

const Item = styled.div`
  border: 0px;
  padding: 4px 16px;
  border-radius: 90px;
  background: rgba(0, 0, 0, 0.30);
  color: #FFF;
  margin-left: auto;
  display: block;
  width: 200px;
  text-align: center;
  padding: 10px;
  margin-bottom: 20px;
  margin-right: 20px;
  
  position: fixed;
  right: 0px;
  bottom: 0px;
  a {
    color: #FFF;
  }
`;

const PoweredBy = () => {
  return (
    <Item className='poweredBy'>
      {t`Powered by`}{' '}<a href='https://www.easyllama.com/' target='_blank' rel='noreferrer'>EasyLlama</a>
    </Item>
  );
};

export default PoweredBy;
